import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initAnalytics } from './services/analytics';
import { capturePlatformCode, captureReferralCode } from './platform';
import './i18n';
import './security/noInspect';
import './styles/global.css';

// SPA deep-link restore — when a sub-route is hard-refreshed, the static host
// (Render) serves /404.html, which stashes the original path and bounces to /.
// Replay it here, before React Router reads the URL, so the route is preserved.
const spaRedirect = sessionStorage.getItem('spa-redirect');
if (spaRedirect) {
  sessionStorage.removeItem('spa-redirect');
  history.replaceState(null, '', spaRedirect);
}

// Multi-tenant: bind the visitor to the operator whose link they arrived on
// (?p=<CODE>). Persist it now, after the SPA-redirect replay restores the real
// URL and before React Router reads it, so it survives navigation to /register.
capturePlatformCode();
// Same for a referral link (?ref=<CODE>): persist it now so it survives the
// navigation to /register and powers the "«name» sent you $5" banner.
captureReferralCode();

initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
